// extracted by mini-css-extract-plugin
export default {"logo":"Location_logo__R7e5+","hiddenformobile":"Location_hiddenformobile__QSgEJ"};